

























	import { Component, Vue } from 'vue-property-decorator'
    import Slick from 'vue-slick'
    import * as Slider from '@/assets/scripts/BeforeAfterSliderModule'

	@Component({
		name: 'Slider',
		components: { Slick },
	})
	export default class BeforeAfterSlider extends Vue {
		data() {
			return {
				title: 'Custom slider with before and after classes',
				SlickOptions: {
					 dots: true,
					 infinite: true,
					 speed: 800,
					 fade: true,
					 waitForAnimate: true,
					 cssEase: 'ease-in-out',
					 responsive: [
						// You can unslick at a given breakpoint now by adding:
						// settings: "unslick"
						// instead of a settings object
					]
				}
			}
		}
        mounted() {
            new Slider.SliderModule(null, null, null, null, null)
		}
		runEvent(event, slick) {
			new Slider.SliderModule(event, slick, event.type, null, null)
        }
        beforeChange(event, slick, currentSlide, nextSlide) {
            new Slider.SliderModule(event, slick, event.type, currentSlide, nextSlide)
		}
	}
